import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-finite";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _typeof from "@babel/runtime/helpers/esm/typeof";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n  align-content: flex-start;\n  -webkit-font-smoothing: antialiased;\n  height: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';

var calcHeight = function calcHeight(adjustHeight) {
  var offset;

  switch (_typeof(adjustHeight)) {
    case 'string':
      {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
          // this is executed in SSR
          // document is not defined
          break;
        }

        var elem = document.getElementById(adjustHeight) || document.querySelector(adjustHeight);

        if (elem && elem.offsetHeight) {
          offset = elem.offsetHeight;
        }

        break;
      }

    case 'number':
      {
        offset = adjustHeight;
        break;
      }

    case 'function':
      {
        offset = adjustHeight();
        break;
      }

    default:
      {
        break;
      }
  }

  return Number.isFinite(offset) ? "calc(100vh - ".concat(offset, "px)") : '100vh';
};

var AppLayout = styled.div(_templateObject(), function (_ref) {
  var adjustHeight = _ref.adjustHeight;
  return calcHeight(adjustHeight);
});
export default AppLayout;